import Color from 'color';
import React from 'react';

import ColorPicker from '../../../../../ColorPicker';
import {
  useMediaObject3DBackgroundColorDisplay,
  useShouldShowMediaObject3DBackgroundColorResetAtLevel,
} from '../../../hooks';
import {SettingTitle} from '../../common/SettingTitle';
import {useMediaSettingsContext} from '../../contexts/MediaSettingsContextProvider';

export const Object3DBackgroundColor = () => {
  const {updateConfig, unsetConfigField, settingsLevel, panelRef} =
    useMediaSettingsContext();
  const {r, g, b, a} = useMediaObject3DBackgroundColorDisplay(
    settingsLevel,
    panelRef
  );
  const isSetAtLevel = useShouldShowMediaObject3DBackgroundColorResetAtLevel(
    settingsLevel,
    panelRef
  );
  const backgroundColor = `rgba(${r}, ${g}, ${b}, ${a})`;
  const setColor = (color: string) => {
    const chosenColor = Color(color);
    updateConfig({
      object3DBackgroundColor: {
        r: chosenColor.red(),
        g: chosenColor.green(),
        b: chosenColor.blue(),
        a: chosenColor.alpha(),
      },
    });
  };
  return (
    <div className="flex justify-between">
      <SettingTitle
        title="Background color"
        configField="object3DBackgroundColor"
        isDirty={isSetAtLevel}
        unsetConfigField={() => unsetConfigField('object3DBackgroundColor')}
      />
      <ColorPicker
        activeColor={backgroundColor}
        setColor={setColor}
        trigger="button"
        invertColorsInDarkMode={false}
      />
    </div>
  );
};
